<template>
  <div>
    <commBanner :obj="obj" navType="8"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 fsb mb-60">
      <div style="width: 70%">
        <div class="news_item_nav">
          <ul>
            <li :class="current == -1?'active':''"
             @click="onwhole(-1)" 
             @mouseenter="mouseover(-1)"
             >全部</li>
            <li
              :class="current == index ? 'active' : ''"
              v-for="(item, index) in dictList"
              :key="index"
              @click="navChange(index,item)"
              @mouseenter="mouseover(index,item)"
              @mouseleave="mouseLeave(item)"
            >
              {{ item.name }}
            </li>
            <li>
             </li>
          </ul>
        </div>
        <div class="list fdw">
          <div
            class="active_contmer"
            v-for="(item, index) in expertList"
            :key="index"
          >
            <expert-card :info="item"></expert-card>
          </div>
        </div>

        <!--分页-->
         <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.curPage"
          :limit.sync="listQuery.limit"
          @pageChange="pageChange"
        ></Pagination>
      </div>
      <div style="width: 26%">
        <div class="find_right" v-if="advList.length>0">
          <a :href="'//'+advList[0].url" target="_blank">
            <img :src="advList[0].image" alt="" />
            <span>广告</span>
          </a>
        </div>
        <newsRecommend
          class="mt-10"
          :newsRecommendObj="newsRecommendObj"
          urlType="technology_detail"
          @dataRefresh="randomNewsList"
        ></newsRecommend>
        <prodSide
          class="mt-10"
          :prodSideObj="prodSideObj"
          @randomData="randomLessonList"
        ></prodSide>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getExpertList,
  getLessonList,
  getTechnologyList,
  getAdv
} from "@/api/information";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import newsRecommend from "../../common/newsRecommend";
import prodSide from "../../common/prodSide";
import { getRandomArray } from "@/utils/index";
import expertCard from "../../components/expertCard";
import Pagination from "../../components/Pagination";
export default {
  components: { commBanner, titleHead, newsRecommend, prodSide, expertCard ,Pagination},
  data() {
    return {
      headTitle: "环保达人",
      obj: {
        title: "环保达人",
        isShow: false,
        isExpert: false,
        roleType:'',
        personalType:8
      },
      expertList: [],
      curPage: 1,
      limit: 6,
      total: 0,
      current: -1,
      newsRecommendObj: {
        title: "专家视角",
        text: "换一批",
        isImg: false,
        newData: [],
      },
      prodSideObj: {
        prodTitle: "推荐课程",
        prodText: "换一批",
        isShow: true,
        prodData: []
      },
      allLessonList: [],
      listQuery: {
        curPage: 1,
        limit: 9,
	    	industry:''
      },
      allNewsList: [],
      advType: 10,
      advList: [],
    };
  },
  created() {
    this.getRecommenedLesson();
    this.getTechnologyList();
    this.getAdv();
    this.getMate()
    if(this.$store.state.user.userInfo != null){
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  computed: {
    dictList() {
      return (
        this.$store.state.industry.list.length > 0 &&
        this.$store.state.industry.list[0].children
      );
    },
  },
  watch: {
    dictList: {
      handler: function (val) {
        if (!val) return;
        this.currentType = val[0].id;
        this.getExpertList();
      },
      immediate: true,
    },
  },
  methods: {
     industryList_detection(id){
        var arr = [15,16,17,18]
        if (arr.indexOf(id) != -1){
          return false
        }else{
          return true
        }
      },
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
        if(res.code == 0){
          this.advList = res.page.list;
        }
      });
    },
    //获取专家视角列表
    getTechnologyList() {
      getTechnologyList({
        ...this.listQuery,
        recommend: 1,
      }).then((res) => {
        if(res.code == 0){
         this.allNewsList = res.page.list;
         this.randomNewsList();
        }
      });
    },
    randomNewsList() {
      this.newsRecommendObj.newData = this.getRandomList(this.allNewsList, 4);
    },
    //跳转专家详情
    toDetail(item) {
      this.$router.push({
        path: "/expert_detail",
        query: { id: item.userId },
      });
    },
    //获取推荐课程
    getRecommenedLesson() {
      getLessonList({
        recommend: 1,
      }).then((res) => {
        if(res.code == 0){
         this.allLessonList = res.page.list;
         this.randomLessonList();
        }
      });
    },
    randomLessonList() {
      this.prodSideObj.prodData = this.getRandomList(this.allLessonList, 2);
    },
    getRandomList(list, length) {
      return _.compact(getRandomArray(_.cloneDeep(list), length));
    },
    //分页查询专家库列表
    getExpertList() {
      getExpertList({
        ...this.listQuery,
        weight:0
      }).then((res) => {
        const { data } = res;
        this.expertList = data.list;
        this.total = data.totalCount;
      });
    },
    goToDetail(url) {
      this.$router.push(url);
    },
    //分页
    pageChange(val) {
      // this.curPage = val;
      this.listQuery["curPage"] = val.page;
      this.listQuery["limit"] = val.limit;
      this.getExpertList();
    },
    onwhole(index){
      this.current = index
      this.getExpertList();
    },
	//专家分类
    navChange(index,item) {
      this.current = index;
      this.listQuery.industry = item.id;
      this.getExpertList();
    },
     //hover 移入移出
    mouseover(index,data){
      if(index == -1){
        this.current = index;
        this.listQuery.industry =''
        this.getExpertList();
      }else{
       this.$nextTick(()=>{
          this.current = index;
          this.listQuery.industry = data.id;
          this.listQuery.curPage =1;
          this.getExpertList();
          this.$set(data,'show',true)
       });
      }
    },
    mouseLeave(data){
      this.$set(data,'show',false);
    },
     getMate(){
      var metas = document.getElementsByTagName("meta"); 
      document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    }
  },
};
</script>
<style scoped lang='less'>
.fsb {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}
.mt-40 {
  margin-top: 40px;
}
.mt-90 {
  margin-top: 90px;
}
.mb-60 {
  margin-bottom: 60px;
}
.find_right {
  position: relative;
}
.find_right img {
  width: 100%;
  height: 184px;
}
.find_right span {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.pagination-container {
  margin-top: 40px;
}
.news_item_nav {
  line-height: 62px;
  background: url("../../assets/images/bg_8.jpg") no-repeat center/cover;
  ul {
    display: flex;
    padding: 0 30px;
    li {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 24px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .active {
      position: relative;
      &::after {
        position: absolute;
        bottom: 10px;
        left: 0;
        display: inline-block;
        content: "";
        width: 100%;
        height: 2px;
        background: #ffffff;
      }
    }
  }
}
.list{
  justify-content: left;
  .active_contmer{
    width: 32%;
    margin-right: 2%;
    &:nth-child(3n){
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/other/expert_list.vue